module.exports = __webpack_public_path__ + "fonts/STC-Forward.157bc09a.ttf";